import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '../../../store/config';
import { ReportFilterSettings, ReportRequest, SortingOrder } from './reports.types';
import { Preset } from '../../../core/api/preset/preset.types';
import { InventoryReportType, ReportType } from './reports.constants';
import { Ingredient, IngredientInOrder } from '../ingredients/ingredients.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/reports');

export const getReport = actionCreator.async<ReportRequest, {}>('GET_REPORT');
export const getReportFilterData = actionCreator.async<ReportType | InventoryReportType, {}>('GET_REPORT_FILTER_DATA');
export const getReportByPreset = actionCreator.async<Preset, {}>('GET_REPORT_BY_PRESET');
export const getReportData = actionCreator.async<ReportRequest, {}>('GET_REPORT_DATA');
export const getDownloadList = actionCreator.async<{ entity: string; fileName: string; formatId: string }, {}>(
  'DOWNLOAD_LIST',
);
export const disableDownload = actionCreator<boolean>('DISABLE_DOWNLOAD_BUTTON');
export const updateInventoryReportRow = actionCreator.async<number, Ingredient & { totalPrice: number }>(
  'UPDATE_INVENTORY_REPORT_ROW',
);
export const updateTransactionsReportRow = actionCreator.async<
  number,
  Partial<IngredientInOrder & { summaryWeightMultiplier: number }>
>('UPDATE_TRANSACTIONS_REPORT_ROW');
export const filterReportData = actionCreator.async<
  {
    type: ReportType;
    filterSettings: ReportFilterSettings;
  },
  {}
>('FILTER_REPORT_BY_PREMIX');
export const getReportDataByPreset = actionCreator.async<
  {
    preset: Preset;
    type: ReportType | InventoryReportType;
  },
  any
>('GET_REPORT_DATA_BY_PRESET');

export const setSortingColumn = actionCreator<string>('SET_SORTING_COLUMN');
export const setSortingOrder = actionCreator<SortingOrder>('SET_SORTING_ORDER');
